import http from "./core";

export default {
  async query(filter) {
    return http.post(`api/kiosk/ScheduleEvents`, filter);
  }
};
